import { render } from "./MinorsSection.vue?vue&type=template&id=2c1f5d60"
import script from "./MinorsSection.vue?vue&type=script&lang=js"
export * from "./MinorsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__